import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function PageHero({ eyebrow, title, lead, image }) {
    const ref = useRef(null);
    const { scrollY } = useScroll();
    const imgY = useTransform(scrollY, [0, 600], [0, -80]);

    return (
        <section ref={ref} className="relative pt-40 lg:pt-52 pb-24 lg:pb-32 overflow-hidden" data-testid="page-hero">
            <motion.div style={{ y: imgY }} className="absolute inset-0 -z-10">
                <img
                    src={image}
                    alt=""
                    className="w-full h-[120%] object-cover opacity-25"
                    style={{ filter: "grayscale(50%) contrast(1.05)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-paper/60 via-paper/85 to-paper"></div>
                <div className="absolute inset-0 bg-grid opacity-30"></div>
            </motion.div>

            <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
                {eyebrow && (
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="flex items-center gap-4 mb-10"
                    >
                        <div className="w-10 h-px bg-gold"></div>
                        <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold">{eyebrow}</span>
                    </motion.div>
                )}

                <motion.h1
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.15 }}
                    className="font-serif text-[44px] sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl leading-[0.95] tracking-[-0.03em] max-w-[1200px]"
                >
                    {title}
                </motion.h1>

                {lead && (
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, delay: 0.4 }}
                        className="mt-10 text-navy/70 text-lg lg:text-xl max-w-[720px] leading-relaxed"
                    >
                        {lead}
                    </motion.p>
                )}
            </div>
        </section>
    );
}
